import Vue from "vue";
import { extend, localize } from "vee-validate";
import * as rules from 'vee-validate/dist/rules';
import es from "vee-validate/dist/locale/es.json";
import en from "vee-validate/dist/locale/en.json";

Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});

extend('confirmed_ci', {
    params: ['target'],
    validate(value, { target }) {
        return value.toLowerCase() == target.toLowerCase();
    },
    message: es.messages.confirmed,
});

extend('identificacion', {
    /**
     * @param {string} value
     * @param {Array} args
     */
    validate(value, { tipo }) {
        if (!tipo) return false;

        const expresiones = {
            dni: /^[0-9]{8}[A-Za-z]$/,                        // 12345678Z
            nie: /^[XYZ][0-9]{7}[A-Za-z]$/,                   // X1234567L
            nif: /^[A-HJ-NP-SUVW][0-9]{7}[0-9A-J]$/,          // B12345678
            pasaporte: /^[A-Za-z0-9]{5,20}$/,                 // Libre
        };

        const regex = expresiones[tipo.toLowerCase()];
        if (!regex) return false;

        return regex.test(value);
    },
    params: ['tipo'],
    message: values => {
        const tipo = values.tipo?.toLowerCase?.() || 'documento';
        return `El ${tipo} introducido no es válido`;
    }
});

extend('nombrePlantilla', {
    validate: value => {
        const regex = /^[a-z0-9_]+$/;
        return regex.test(value);
    },
    message: 'Solo se permiten letras minúsculas, números y guiones bajos',
});

extend('url', {
    validate: value => {
        const regex = /^(https?:\/\/)?([\w.-]+)\.([a-z]{2,})(\/\S*)?$/i;
        return regex.test(value);
    },
    message: 'Debe ser una URL válida (ej: https://ejemplo.com)'
});

localize({
    en: {
        messages: en.messages
    },
    es: {
        messages: es.messages
    }
});

let LOCALE = "es";

// A simple get/set interface to manage our locale in components.
// This is not reactive, so don't create any computed properties/watchers off it.
Object.defineProperty(Vue.prototype, "locale", {
    get() {
        return LOCALE;
    },
    set(val) {
        LOCALE = val;
        localize(val);
    }
});